import http from '../api/http'
import qs from 'qs'

//登录
//获取图片验证码
export function getImageCode(params) {
  return http.get('user/verification/getImageCode', params)
}
//验证手机号是否存在
export function isPhoneExist(params) {
  return http.get('user/userAccount/isPhoneExist', params)
}
//登录接口
export function logins(params) {
  return http.post('/login', params)
}


//忘记密码
//发送短信接口
export function sendSMSCode(params) {
  return http.get(`user/verification/sendSMSCode`, params)
}
//忘记密码
export function forgotPassWord(params) {
  return http.post(`/user/userAccount/forgotPassWord`, qs.stringify(params))
}


//重置密码
//重置密码
export function forgotPassWordReset(params) {
  return http.post(`/user/userAccount/forgotPassWordReset`, qs.stringify(params))
}


//替换手机
//验证手机号与账号是否绑定
export function verificationPhoneIsBinding(params) {
  return http.get(`/user/userAccount/verificationPhoneIsBinding`, params)
}
//修改手机号前置条件
export function modifyPhonePre(params) {
  return http.get(`/user/userAccount/modifyPhonePre`, params)
}
//修改手机号
export function modifyPhone(params) {
  return http.post(`/user/userAccount/modifyPhone`, qs.stringify(params))
}


//充值统计
//查询充值记录
export function currencyRechargeRecord(params) {
  return http.get(`/assets/currencyRechargeRecord/query`, params)
}


//资产统计
//当前资产统计
export function queryAssetsStatistics(params) {
  return http.get(`/assets/assetsStatistics/queryAssetsStatistics`, params)
}
//获取充值身份手机验证码
export function rechargeVerificationPhoneCode(params) {
  return http.get(`/assets/currency/rechargeVerificationPhoneCode`, params)
}
//获取充值身份图片验证码
export function rechargeVerificationImageCode(params) {
  return http.get(`/assets/currency/rechargeVerificationImageCode`, params)
}
//充值身份验证
export function getRechargeVerificationCode(params) {
  return http.get(`/assets/currency/getRechargeVerificationCode`, params)
}
//查询利率
export function queryMoneyRate(params) {
  return http.get(`/assets/moneyRate/queryMoneyRate`, params)
}
//充值
export function rechargeAmountByAccountNO(params) {
  return http.post(`/assets/currency/rechargeAmountByAccountNO`, qs.stringify(params))
}

/**
 * 更新直播间恢复使用
 * @param params
 * @returns {AxiosPromise}
 */
export  function updateLiveRoomRecoveryByAccountNO(params)
{
  return http.post("/liveRoomService/liveRoomDisable/updateLiveRoomRecoveryByAccountNO",qs.stringify(params))
}


//当前资产明细
// 资产详情
export function queryAssetsDetail(params) {
  return http.get(`/assets/assetsDetail/queryAssetsDetail`, params)
}


//收益
//收益统计 大饼图
export function queryProfitStatistics(params) {
  return http.get(`/assets/assetsStatistics/queryProfitStatistics`, params)
}
//收益统计 详情
export function queryProfitStatisticsDetail(params) {
  return http.get(`/assets/assetsStatistics/queryProfitStatisticsDetail`, params)
}


//收益
//添加产品
export function add(params) {
  return http.post(`/product/productService/add`,  qs.stringify(params))
}
//查询产品
export function query(params) {
  return http.get(`/product/productService/query`, params)
}
//禁用产品
export function updateIsEnable(params) {
  return http.post(`/product/productService/updateIsEnable`, qs.stringify(params))
}
//删除产品
export function productServicedelete(params) {
  return http.post(`/product/productService/delete`, qs.stringify(params))
}